export default __webpack_public_path__ + "static/media/preload-cropped.8cdacebb.gif";